import * as _ from 'lodash';
import { StepAction } from './stepAction';
import { getLogger } from '../../commons/logger';
import { eyeSdkService } from '../utils/eyeSdkService';
import type { RunContext } from './stepAction';
import type { ExtendedContext } from 'clickim/src/background/eyesUtils';
import type { SimpleUIVerificationStep } from 'clickim/src/common/models/simpleUiVerificationStep';
import type { ExecutionResult } from 'clickim/src/background/stepActions/pixelValidationStepAction';

const logger = getLogger('pixel-validation-step-action');

export class PixelValidationStepAction extends StepAction<SimpleUIVerificationStep, ExtendedContext> {
    private runContext!: RunContext;

    override async performAction() {
        const { shouldUseVisualGrid, applitoolsSdkConfig: config, applitoolsSdkLogger, testResultId } = this.context;
        this.runContext = this.context.getRunContext(undefined);
        const finalParams = this.runContext.incomingParams?.final || {};
        // @ts-expect-error Applitools types in current SDK version are a pile of poopoo
        const batchId = config.batch?.id || testResultId;
        const eyeManager = await eyeSdkService.getManager(shouldUseVisualGrid, this.context.config.applitoolsConcurrency || 5, batchId, this.runContext.applitoolsIntegrationData!);
        const targetElementData = this.getTarget() || {};
        let result: ExecutionResult;
        try {
            // @ts-expect-error Applitools types in current SDK version are a pile of poopoo
            const openedEye = await eyeManager.openEyes({ driver: this.driver.client, config, logger: applitoolsSdkLogger });
            const region = (this.step.action === 'element' && targetElementData.seleniumElement) || undefined;
            const settings = { region, fully: this.step.action === 'stitched' };
            if (_.isPlainObject(finalParams.applitoolsStepSettings)) {
                Object.assign(settings, finalParams.applitoolsStepSettings);
                logger.info('Applitools SDK step executed with applitoolsStepSettings parameter', { applitoolsStepSettings: finalParams.applitoolsStepSettings });
            }
            // @ts-expect-error Applitools types in current SDK version are a pile of poopoo
            await openedEye.check({ settings });
            const eyesResults = await openedEye.close();

            // @ts-expect-error Applitools types in current SDK version are a pile of poopoo
            result = { isApplitoolsSdkResult: true, success: true, eyesResults };
            logger.info('Applitools SDK step executed successfully (selenium mode)', { projectId: this.context.projectId });
        } catch (err) {
            logger.error('Applitools SDK step failed', { err, info: err.info });
            result = { isApplitoolsSdkResult: true, success: false, err };
        }
        return await eyeSdkService.handleApplitoolsSdkResult(this.context, result, this.step as unknown as SimpleUIVerificationStep);
    }
}
